import dayjs from 'dayjs';
import React from 'react';
import { Modal } from 'react-bootstrap';
import IconButton from '../common/IconButton';
import './PTOApprovalError.css'

type PtoErrorType = {
    date: any,
    errorMessage: string
}

interface IProps {
    showPTOErrorMessage: boolean;
    setShowPTOErrorMessage: Function;
    ptoApprovalErrorList: PtoErrorType[] | undefined;
}

const PTOApprovalError: React.FC<IProps> = (props) => {
    const { showPTOErrorMessage, setShowPTOErrorMessage, ptoApprovalErrorList } = props;


    const closePTOErrorMessage = () => {
        setShowPTOErrorMessage(!showPTOErrorMessage);
    }

    return(
        <Modal dialogClassName='pto-modal-error' show={showPTOErrorMessage} centered>
            <Modal.Header>
                <h3 className='pto-modal-error-header text-danger'>Error with Request</h3>
            </Modal.Header>
            <Modal.Body>
                <h5 className='pto-modal-error-text text-center'>One or more of your requests were not completed due to</h5>
                <hr/>
                {
                    ptoApprovalErrorList !== undefined &&
                    ptoApprovalErrorList.map((errorItem) => {
                        let itemDate = dayjs.utc(errorItem.date)
                    return(
                            <>
                                <h6>
                                    {itemDate.local().format('MM/DD/YYYY')}: {errorItem.errorMessage}
                                </h6>
                                <hr/>
                            </>
                        )
                    })
                }
            </Modal.Body>
            <Modal.Footer>
            <IconButton onClick={() => closePTOErrorMessage()} buttonClassName="action-text-danger" icon="close">Close</IconButton>
            </Modal.Footer>
        </Modal>
    )
}

export default PTOApprovalError;